import { IState } from '../index';

export function getNewState(state: IState, index: number) {
  const newState: IState = {};

  Object.keys(state).map((key: keyof typeof newState) => {
    if (String(key) === String(index) && state[key]) {
      newState[key] = false;

      return;
    }

    newState[key] = String(key) === String(index);
  });

  return newState;
}
